export default __webpack_public_path__ + "static/media/27.9e838d72.jpg";